export const PROGRAM_GROUP_INFO = {
  tnt: {name: 'TNT', domain: 'teamintraining.org', contactMail: 'supportservices@lls.org', logo: 'logo-tnt-white.png', callNumber:'800.482.TEAM'},
  ltn: {name: 'LTN', domain: 'lightthenight.org', contactMail: 'supportservices@lls.org', logo: 'logo-ltn-color.png', callNumber:'877.LTN.Walk'},
  mwoy: {name: 'MWOY', domain: 'llsvisionaries.org', contactMail: 'supportservices@lls.org', logo: 'logo-voy-white.png', callNumber:'888.LLS.7177'},
  soy: {name: 'SOY', domain: 'llsstudentvisionaries.org', contactMail: 'supportservices@lls.org', logo: 'logo-soy-white.png', callNumber:'888.LLS.7177'},
};

export const apiBaseUrl = '/OnlineRegistration/service/api/';
